// Visually-hidden `aria-live="polite"` region — pair with `useLiveAnnouncer`
// (docs/06-ux-rules.md "Live region" / P10 D5). `.sr-only` is the repo's
// existing visually-hidden utility class (see
// OrderSatisfactionMetric.tsx/LocationMultiSelect.tsx).
import React from 'react'

interface Props {
  message: string
}

const LiveRegion = ({ message }: Props) => (
  <div aria-live="polite" role="status" className="sr-only">
    {message}
  </div>
)

export default LiveRegion
